import { process } from '../mock';

const Process = () => (
  <section id="process" className="section">
    <span className="section-eyebrow">Comment ça marche</span>
    <h2 className="section-title">
      Un processus <em>simple</em> et transparent.
    </h2>
    <p className="section-desc">
      De la première discussion à la mise en ligne, chaque étape est claire. Vous savez où vont vos euros et à quoi ressemble votre site avant même la livraison.
    </p>
    <div className="process-grid">
      {process.map((p) => (
        <div key={p.step} className="process-card">
          <div className="process-step">{p.step}</div>
          <h3 className="process-title">{p.title}</h3>
          <p className="process-text">{p.text}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Process;
